

export const isNumber = {
    name: "isNumber",
    validate: (value) => !value || !isNaN(value),
};
